const DB_NAME = "speak-meeting-reminders";
const DB_VERSION = 1;
const STORE_NAME = "session";
const FLAG_KEY = "state";

// IndexedDB, not localStorage, because the service worker has no localStorage but must know if anyone is signed in.
function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE_NAME);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Holds only the user id, never a token: the worker needs to know who is signed in, nothing more.
async function writeFlag(userId: string | null): Promise<void> {
  const database = await openDatabase();
  try {
    await new Promise<void>((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, "readwrite");
      transaction.objectStore(STORE_NAME).put({ userId }, FLAG_KEY);
      transaction.oncomplete = () => resolve();
      transaction.onerror = () => reject(transaction.error);
      transaction.onabort = () => reject(transaction.error);
    });
  } finally {
    database.close();
  }
}

export function markSignedIn(userId: string): Promise<void> {
  return writeFlag(userId);
}

export function markSignedOut(): Promise<void> {
  return writeFlag(null);
}

export async function readSignedInUserId(): Promise<string | null> {
  try {
    const database = await openDatabase();
    try {
      const value = await new Promise<unknown>((resolve, reject) => {
        const request = database.transaction(STORE_NAME, "readonly").objectStore(STORE_NAME).get(FLAG_KEY);
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      });
      const userId = (value as { userId?: unknown } | undefined)?.userId;
      return typeof userId === "string" && userId.length > 0 ? userId : null;
    } finally {
      database.close();
    }
  } catch {
    // An unreadable flag counts as signed out so the worker shows nothing.
    return null;
  }
}
